import { Routes, Route } from "react-router-dom";

// Layouts
import MainLayout from "../components/layouts/MainLayout";

// Core Pages
import Home from "../components/pages/Home";
import FlightsHub from "../components/pages/FlightsHub";
import AirlineDetail from "../components/pages/AirlineDetail";
import RailHub from "../components/pages/RailHub";
import RailDetail from "../components/pages/RailDetail";
import CarsHub from "../components/pages/CarsHub";
import CarDetail from "../components/pages/CarDetail";
import About from "../components/pages/About";
import Contact from "../components/pages/Contact";
import FAQ from "../components/pages/FAQ";
import PrivacyPolicy from "../components/pages/PrivacyPolicy";
import TermsAndConditions from "../components/pages/TermsAndConditions";

// Flight Service Pages
import Support247 from "../components/pages/Support247";
import FlightDeals from "../components/pages/FlightDeals";
import GroupTravel from "../components/pages/GroupTravel";
import SpecialAssistance from "../components/pages/SpecialAssistance";
import FlightBooking from "../components/pages/FlightBooking";

// Rail Service Pages
import TrainBooking from "../components/pages/TrainBooking";
import TrainDeals from "../components/pages/TrainDeals";
import TrainSchedules from "../components/pages/TrainSchedules";
import TrainSupport247 from "../components/pages/TrainSupport247";
import FamilyTrainTravel from "../components/pages/FamilyTrainTravel";
import BusinessTrainTravel from "../components/pages/BusinessTrainTravel";

// Car Rental Service Pages
import CarRentalBooking from "../components/pages/CarRentalBooking";
import AirportCarRental from "../components/pages/AirportCarRental";
import LuxuryCarRental from "../components/pages/LuxuryCarRental";
import SUVCarRental from "../components/pages/SUVCarRental";
import LongTermCarRental from "../components/pages/LongTermCarRental";
import CarSupport from "../components/pages/CarSupport";

export default function AppRouter() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        {/* Core Nav Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/terms-and-conditions"
          element={<TermsAndConditions />}
        />

        {/* Flight Hub & Services */}
        <Route path="/flights" element={<FlightsHub />} />
        <Route path="/flights/:airlineSlug" element={<AirlineDetail />} />
        <Route path="/rail" element={<RailHub />} />
        <Route path="/rails" element={<RailHub />} />
        <Route path="/rail/:railSlug" element={<RailDetail />} />
        <Route path="/support24x7" element={<Support247 />} />
        <Route path="/flight-deals" element={<FlightDeals />} />
        <Route path="/group-travel" element={<GroupTravel />} />
        <Route path="/special-assistance" element={<SpecialAssistance />} />
        <Route path="/booking" element={<FlightBooking />} />

        {/* Rail Services */}
        <Route path="/train-booking" element={<TrainBooking />} />
        <Route path="/train-deals" element={<TrainDeals />} />
        <Route path="/train-schedules" element={<TrainSchedules />} />
        <Route path="/24-7-train-support" element={<TrainSupport247 />} />
        <Route path="/family-train-travel" element={<FamilyTrainTravel />} />
        <Route path="/business-train-travel" element={<BusinessTrainTravel />} />

        {/* Car Hub & Services */}
        <Route path="/cars" element={<CarsHub />} />
        <Route path="/cars/:carSlug" element={<CarDetail />} />
        <Route path="/car/car-rental-booking" element={<CarRentalBooking />} />
        <Route path="/car/airport-car-rental" element={<AirportCarRental />} />
        <Route path="/car/luxury-car-rental" element={<LuxuryCarRental />} />
        <Route path="/car/suv-car-rental" element={<SUVCarRental />} />
        <Route
          path="/car/long-term-car-rental"
          element={<LongTermCarRental />}
        />
        <Route path="/car/24x7-support" element={<CarSupport />} />
      </Route>
    </Routes>
  );
}
